import React, { useEffect, useState } from "react";
import { Form } from "antd";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getGroupCompleted, scheduleCancellation } from "../../../../reducers/groups/actions";
import * as Actions from "../../../../reducers/schedule/actions";
import ScheduleCancellationForm from "../ScheduleCancellationForm/ScheduleCancellationForm";
import moment from 'moment';

import "./ScheduleCancellationModal.scss";

function ScheduleCancellationModal(props) {

  const {
    groupsReducer,
    getGroupCompleted,
    startDate,
    match: { params },
  } = props;

  const { group } = groupsReducer;

  const { id: groupId } = params;

  const [values, setValues] = useState({
    start_date: moment(startDate, 'DD-MM-YYYY')
  });

  const [form] = Form.useForm();

  useEffect(() => {
    groupId && getGroupCompleted(groupId);
  }, [groupId]);

  useEffect(() => {
    form.setFieldsValue({
      start_date: moment(startDate, 'DD-MM-YYYY')
    });
  }, [group]);

  return (
    <ScheduleCancellationForm
      {...props}
      group={group}
      form={form}
      values={values}
      setValues={setValues}
      groupId={groupId}
    />
  );
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...Actions, getGroupCompleted, scheduleCancellation }, dispatch);
const mapStateToProps = (state) => ({
  groupsReducer: state.get("groupsReducer"),
});

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleCancellationModal);
